import defaultTheme from './themedefault';
import {cloneDeep} from 'lodash';

const theme = cloneDeep(defaultTheme);
theme.palette.primary = ['#f00'];
theme.palette.secondary = ['#0f0'];
export default theme;
